import { MsgService } from './../../../share/msg/msg.service';
import { Injectable, NgZone } from '@angular/core';
import { Subscription } from 'rxjs';
import { Observable } from 'rxjs';
import { ImportEmpCsvService } from './import-emp-csv.service';
import * as wjcCore from '@grapecity/wijmo';
import * as MSG from '../../../share/msg/msg';
import { SMILE9_ROLES } from '../../../../environments/environment';
enum Mode {
  None,
  Create,
  Edit,
  Delete,
  DeleteEmpTask,
  History,
  DisplayStatus,
}

@Injectable()
export class ImportEmpCsvObserveUpdateService {

  public checkReadyCount$: Subscription = null;
  public latestEmpAtOnce = 0;
  public gridSource: wjcCore.CollectionView = new wjcCore.CollectionView(null);
  public succeededRecords: any[] = [];
  public currentMode = Mode.None;
  public Mode = Mode;
  private connectingApi = false;

  constructor(
    private msgServ: MsgService,
    private reqApi: ImportEmpCsvService,
    private ngZone: NgZone,
  ) { }

  /** 社員データ一括更新の監視を開始。ImportEmpCsvStatusComponentが生成された時に実行され、GaMasterComponentが破棄されるまで継続される。 */
  public async startObserveAsync(): Promise<void> {
    this.latestEmpAtOnce = 0;
    this.currentMode = this.Mode.DisplayStatus;
    this.gridSource.sourceCollection.length = 0;
    await this.getCurrentEmpAtOnceListAsync();

    if (this.checkReadyCount$ === null) {
      /** 処理対象データのupd_atのMAX値をDBから定期取得 */
      this.checkReadyCount$ = Observable
      .interval(5000)
      .subscribe(_ => {
        if (this.connectingApi) { return; }
        this.getLatestEmpAtOnceAsync();
      });
    }
  }

  /** 社員データ一括更新の監視を中断。GaMasterComponentのngOnDestroy()から呼ばれる。 */
  public stopObserve(): void {
    if (this.checkReadyCount$ && !this.checkReadyCount$.closed) {
      this.checkReadyCount$.unsubscribe();
    }
    this.checkReadyCount$ = null;
  }

  /** 処理対象データのupd_atのMAX値をDBから取得 */
  public async getLatestEmpAtOnceAsync(): Promise<boolean> {
    this.connectingApi = true;

    const latestEmpAtOnce = await this.reqApi.getLatestEmpAtOnce().catch(err => console.error(err)) as number;
    /** 処理対象データのupd_atのMAX値が更新された = 更新用Lambda側で処理が実行されたと判定。処理対象データのリストの取得開始。 */
    if (latestEmpAtOnce !== this.latestEmpAtOnce) {
      await this.getCurrentEmpAtOnceListAsync();
    }
    this.latestEmpAtOnce = latestEmpAtOnce;

    this.connectingApi = false;
    return true;
  }

  /** 処理対象のデータをDBから取得 */
  private async getCurrentEmpAtOnceListAsync(): Promise<boolean> {
    const atOnceList = await this.reqApi.getCurrentEmpAtOnceList().catch(err => console.error(err));
    if (atOnceList) {
      this.ngZone.run(() => {
        let textColorClass = '';
        this.gridSource.sourceCollection = atOnceList.map(row => {
          switch (row.status) {
            case 'succeeded':
              textColorClass = 'text-success';
              break;
            case 'failed':
              textColorClass = 'text-danger';
              break;
          }
          if (textColorClass !== '') {
            row['originGridClass-status_name'] = textColorClass;
            row['originGridClass-content'] = textColorClass;
            row['originGridClass-content'] = textColorClass;
            row['originGridClass-co_name_with_code'] = textColorClass;
            row['originGridClass-dept_name_with_code'] = textColorClass;
            row['originGridClass-emp_name_with_code'] = textColorClass;
            row['originGridClass-username'] = textColorClass;
            row['originGridClass-crt_at'] = textColorClass;
          }
          return row;
        });
        this.succeededRecords = atOnceList.filter(record => record.status === 'succeeded');
      });

      // 全て処理完了した
      if (atOnceList.filter(record => record.status !== 'ready').length === atOnceList.length) {
        this.updateCompleted(atOnceList);
        this.stopObserve();
        return true;
      }
    }
    return true;
  }

  private updateCompleted(atOnceList: any[]): void {
    if (atOnceList.some(record => record.status === 'failed')) {
      this.msgServ.warning(MSG.WARNING.FAILED_UPDATE_AT_ONCE, '');
    } else {
      this.msgServ.success(MSG.SUCCESS.COMPLETE('全ての社員データの更新'), '');
    }

    this.ngZone.run(() => {
      this.gridSource.sourceCollection = [];
      this.currentMode = this.Mode.None;
    });
  }

  /** smile9Role=総務ではない場合は、社員データ一括更新監視を中断 */
  public checkGeneralAffairsToken(smile9Role: string) {
    if (smile9Role !== SMILE9_ROLES.GENERAL_AFFAIRS) {
      this.stopObserve();
    }
  }

  public reset(): void {
    this.currentMode = Mode.None;
    this.Mode = Mode;
  }
}
